import { createSelector } from 'reselect';

const resendOtpReducer = state => {
  return state.ResendLoginOtpReducer;
};

const selectResendOtpData = createSelector(resendOtpReducer, data => data);

export { selectResendOtpData };
